const gstRegExr = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9A-Z]{1}$/i;
const cinRegExr = /^([LUu]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/gm;
const cinRegExrllp = /^[A-Z]{3}-\d{4}$/i;
const cinRegExrf = /^f\d{5}$/i;
const msmeRegExr = /^UDYAM-[A-Za-z]{2}-\d{2}-\d{7}$/i;
const panRegExr = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/i;
const dinRegExr = /^\d{8}$/;
const bankRegExr = /^\d{6}$/;
const iecRegExr = /^(\d{10}|[A-Z]{5}[0-9]{4}[A-Z]{1})$/i;
const mobile360RegExr = /^\d{10}$/;
const emailRegExr = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
const darpanRegExr = /^[A-Z]+\/\d{1,5}\/\d{4}\/[A-Z]+$/i;

const ServiceRegExr = {
    gstRegExr,
    cinRegExr,
    msmeRegExr,
    panRegExr,
    dinRegExr,
    cinRegExrllp,
    cinRegExrf,
    emailRegExr,
    mobile360RegExr,
    iecRegExr,
    bankRegExr,
    darpanRegExr
}

export default ServiceRegExr;